import { render, staticRenderFns } from "./Select.desktop.vue?vue&type=template&id=042809a4&scoped=true&"
import script from "./Select.desktop.vue?vue&type=script&lang=js&"
export * from "./Select.desktop.vue?vue&type=script&lang=js&"
import style0 from "./Select.desktop.vue?vue&type=style&index=0&id=042809a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042809a4",
  null
  
)

export default component.exports